import { graphql } from '@api/generated';

import { getClient } from '../../../api/client';

const getWebPhoneTokenQuery = graphql(`
  query webPhoneToken {
    currentUser {
      webPhoneToken
    }
  }
`);

async function getWebPhoneToken(): Promise<string> {
  const { data, error } = await getClient().query({
    fetchPolicy: 'network-only',
    query: getWebPhoneTokenQuery,
  });

  if (error) {
    throw new Error(error.message);
  }

  const user = data?.currentUser;

  if (!user) {
    throw new Error('User not found');
  }

  if (!user.webPhoneToken) {
    throw new Error('Web phone token not found');
  }

  return user.webPhoneToken;
}

export default getWebPhoneToken;
